<template>
  <div style="max-width: 500px" class="mx-auto">
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      เข้าสู่ระบบ
    </div>
    <div>
      <div>
        <div class="text-center mt-8">
          <img width="120px" src="@/assets/logo.png" />
        </div>
      </div>
      <div class="pa-5 mt-4 pb-0">
        <ValidationObserver ref="observer">
          <ValidationProvider
            :rules="{
              required: true,
              digits: 13,
            }"
            name="เลขบัตรประชาชน"
            v-slot="{ errors }"
          >
            <custom-input
              maxlength="13"
              placeholder="เลขบัตรประชาชน"
              prepend-inner-icon="mdi-account"
              background-color="#eee"
              v-model="input.identityNumber"
              outlined
              :error-messages="errors"
            ></custom-input>
          </ValidationProvider>
          <ValidationProvider
            :rules="{
              required: true,
            }"
            name="รหัสผ่าน"
            v-slot="{ errors }"
          >
            <custom-input
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              placeholder="รหัสผ่าน"
              prepend-inner-icon="mdi-lock"
              background-color="#eee"
              v-model="input.password"
              outlined
              :error-messages="errors"
            ></custom-input>
          </ValidationProvider>
        </ValidationObserver>
        <div class="text-right primary--text">
          <span @click="query.view = 'ForgetPassword'">ลืมรหัสผ่าน</span>
        </div>
      </div>
      <div class="text-center mt-3">
        <v-btn
          :loading="saveloading"
          @click="login"
          large
          color="primary"
          class="text-capitalize"
          >Login</v-btn
        >
        <div class="mt-3 grey--text">
          หากยังไม่ได้สมัครสมาชิก<span
            @click="query.view = 'Register'"
            class="primary--text"
          >
            สมัครเลย</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      saveloading: false,
      show1: false,
      input: {
        identityNumber: "",
        password: "",
      },
    };
  },
  methods: {
    async login() {
      if (await this.$refs.observer.validate()) {
        var data = {
          identity_number: this.input.identityNumber,
          password: this.input.password,
          userid: this.userid,
          pageid: this.query.pageid,
        };
        this.saveloading = true;
        axios
          .post(this.serverUrl + "toacrm/login", data, {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.query.tab = "profile";
              this.query.view = "PointManager";
            } else if (response.data.responsecode == 204) {
              await this.$swal.fire({ text: response.data.reason });
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
          });
      }
    },
  },
};
</script>
